export enum StatusCode {
    OK = 200,
    CREATED = 201
}

export const ENTER_KEY = 13;

export const WEB_APP_TITLE = document.title;
